import React from 'react'
import styles from './footer.module.css'
import { Link } from 'react-router-dom'
import { NavHashLink } from 'react-router-hash-link'
import logo from '../../assets/logo.svg'

function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.brand}>
          <Link to="/home" className={styles.brandLink}>
            <img src={logo} alt="" className={styles.logo} />
            <span>Nails by Astraea</span>
          </Link>
          <p>Thoughtful nail artistry, personalized for every visit.</p>
          <Link to="/login" className={styles.bookLink}>Customer Portal</Link>
        </div>

        <nav className={styles.linkGroup} aria-label="Footer navigation">
          <h2>Explore</h2>
          <NavHashLink smooth to="/home#about">About</NavHashLink>
          <NavHashLink smooth to="/home#portfolio">My Work</NavHashLink>
          <NavHashLink smooth to="/home#services">Services</NavHashLink>
          <Link to="/policy">Policies &amp; Ethics</Link>
        </nav>

        <div className={styles.linkGroup}>
          <h2>Contact</h2>
          <a href="mailto:astraea@nailsbyastraea.com">astraea@nailsbyastraea.com</a>
          <a
            href="https://www.google.com/maps/search/?api=1&query=18+Church+Street+Alfred+Station+NY+14803"
            target="_blank"
            rel="noreferrer"
          >
            18 Church Street<br />Alfred Station, NY 14803
          </a>
        </div>

        <div className={styles.footerBottom}>
          <p>&copy; {year} Nails by Astraea</p>
          <p>Alfred Station, New York</p>
        </div>

      </div>
    </footer>
  )
}

export default Footer
